import { ITncRepository } from '../../ports/ITncRepository';
import { TncCase } from '../../domain/entities';

export class StartTncProcessUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(caseId: string): Promise<TncCase> {
    return this.tncRepository.startTncProcess(caseId);
  }
}
